import * as React from 'react';
import { IFormField } from '../../../../interfaces/interfaces';

interface IPhoneProps extends IFormField {
    valuePrefix?: string;
}

export default (props: IPhoneProps) => (
    <div key={props.fieldName} className={'form__item'}>
        <label>
            {props.label}
            {typeof props.isRequired === 'function' ? props.isRequired() : props.isRequired && <span> *</span>}
        </label>
        <input
            type="text"
            name={`prefix` + props.fieldName.charAt(0).toUpperCase() + props.fieldName.slice(1)}
            onChange={props.onChange}
            value={props.valuePrefix || ''}
            className="phonePrefix"
            placeholder={'+420'}
        />
        <input
            type={'text'}
            name={props.fieldName}
            onChange={props.onChange}
            value={props.value || ''}
            className="phoneNumber"
        />
        {props.errorMessage && <p className={'registration__error'}>{props.errorMessage}</p>}
    </div>
);



// WEBPACK FOOTER //
// ./src/components/FormGenerator/Form/components/Phone.tsx